unit UValueModel;

interface

uses
  UEssentialHelper;

type
  TValueModel = class
  private
    FValue: string;
    FOnPropertyChanged: TCallback;
    FEinheit: string;
    FCol: Integer;
    FRow: Integer;
    FTage: string;
    procedure ClearValues;
    procedure PropertyChanged;
    procedure SetValue(const Value: string);
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetEinheit(const Value: string);
    procedure SetCol(const Value: Integer);
    procedure SetRow(const Value: Integer);
    procedure SetTage(const Value: string);
  public
    constructor Create;
    class function IsZero(Value: string): Boolean;
    procedure GetBalance(Url: string; PersonalNr: string; ZeitartId: Integer;
      Datum: TDateTime; DecimalValues: Boolean);
    procedure GetCurrentBalance(Url: string; PersonalNr: string;
      ZeitartId: Integer; DecimalValues: Boolean);
    procedure GetZaSum(Url: string; PersonalNr: string; ZeitartIds: string;
      VonBuDatum: string; BisBuDatum: string; DecimalValues: Boolean);
    procedure GetZaSumTag(Url: string; PersonalNr: string; ZeitartId: Integer;
      Datum: TDateTime; DecimalValues: Boolean);
    procedure GetZaSumZr(Url: string; PersonalNr: string; ZeitartId: Integer;
      Von: TDateTime; Bis: TDateTime; DecimalValues: Boolean);
    property Value: string read FValue write SetValue;
    property Einheit: string read FEinheit write SetEinheit;
    property Tage: string read FTage write SetTage;
    property Col: Integer read FCol write SetCol;
    property Row: Integer read FRow write SetRow;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
  end;

implementation

uses
  WebLib.REST, WebLib.JSON, System.SysUtils, Js;

{ TValueModel }

procedure TValueModel.ClearValues;
begin
  Self.Value := '';
  Self.Einheit := '';
  Self.Tage := '';
  Self.Col := -1;
  Self.Row := -1;
  Self.OnPropertyChanged := nil;
end;

constructor TValueModel.Create;
begin
  Self.ClearValues;
end;

procedure TValueModel.GetBalance(Url, PersonalNr: string; ZeitartId: Integer;
  Datum: TDateTime; DecimalValues: Boolean);
var
  obj: TJsonObject;
  helper: string;
  client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  var
    obj: TJsObject;
  begin
    obj := TJsJson.parseObject(aResponse);
    Self.Value := string(obj['Value']);
    Self.Einheit := string(obj['Einheit']);
    Self.PropertyChanged;
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', PersonalNr);
  obj.AddPair('ZeitartId', IntToStr(ZeitartId));
  obj.AddPair('Datum', FormatDateTime('dd.mm.yyyy', Datum));
  obj.AddPair('DecimalValues', BooleanToStr(DecimalValues));
  helper := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/ValueService/GetBalance', 'application/json',
    obj.ToString);
  client.Free;
  obj.Free;
end;

procedure TValueModel.GetCurrentBalance(Url, PersonalNr: string;
  ZeitartId: Integer; DecimalValues: Boolean);
var
  client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  var
    obj: TJsObject;
  begin
    obj := TJsJson.parseObject(aResponse);
    Self.Value := string(obj['Value']);
    Self.Einheit := string(obj['Einheit']);
    Self.PropertyChanged;
  end;
  function DecodeValue: string;
  var
    obj: TJsonObject;
  begin
    obj := TJsonObject.Create;
    obj.AddPair('PersonalNr', PersonalNr);
    obj.AddPair('ZeitartId', IntToStr(ZeitartId));
    obj.AddPair('DecimalValues', BooleanToStr(DecimalValues));
    Result := obj.ToString;
    obj := TJsonObject.Create;
    obj.AddPair('value', Result);
    Result := obj.ToString;
    obj.Free;
  end;

begin
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/ValueService/GetCurrentBalance', 'application/json',
    DecodeValue);
  client.Free;
end;

procedure TValueModel.GetZaSum(Url, PersonalNr, ZeitartIds, VonBuDatum,
  BisBuDatum: string; DecimalValues: Boolean);
var
  client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  var
    obj: TJsObject;
  begin
    obj := TJsJson.parseObject(aResponse);
    Self.Value := string(obj['Value']);
    Self.Einheit := string(obj['Einheit']);
    Self.Tage := string(obj['Tage']);
    Self.PropertyChanged;
  end;
  function DecodeValue: string;
  var
    obj: TJsonObject;
  begin
    obj := TJsonObject.Create;
    obj.AddPair('PersonalNr', PersonalNr);
    obj.AddPair('ZeitartIds', ZeitartIds);
    obj.AddPair('VonBuDatum', VonBuDatum);
    obj.AddPair('BisBuDatum', BisBuDatum);
    obj.AddPair('DecimalValues', BooleanToStr(DecimalValues));
    Result := obj.ToString;
    obj := TJsonObject.Create;
    obj.AddPair('value', Result);
    Result := obj.ToString;
    obj.Free;
  end;

begin
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/ValueService/GetZaSum', 'application/json',
    DecodeValue);
  client.Free;
end;

procedure TValueModel.GetZaSumTag(Url, PersonalNr: string; ZeitartId: Integer;
  Datum: TDateTime; DecimalValues: Boolean);
var
  obj: TJsonObject;
  helper: string;
  client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  var
    obj: TJsObject;
  begin
    obj := TJsJson.parseObject(aResponse);
    Self.Value := string(obj['Value']);
    Self.Einheit := string(obj['Einheit']);
    Self.PropertyChanged;
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', PersonalNr);
  obj.AddPair('ZeitartId', IntToStr(ZeitartId));
  obj.AddPair('Datum', DateTimeToStr(Datum));
  obj.AddPair('DecimalValues', BooleanToStr(DecimalValues));
  helper := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/ValueService/GetZaSumTag', 'application/json',
    obj.ToString);
  client.Free;
  obj.Free;
end;

procedure TValueModel.GetZaSumZr(Url, PersonalNr: string; ZeitartId: Integer;
  Von, Bis: TDateTime; DecimalValues: Boolean);
var
  obj: TJsonObject;
  helper: string;
  client: TRestClient;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    jso := TJsJson.parseObject(aResponse);
    Self.Value := string(jso['Value']);
    Self.Einheit := string(jso['Einheit']);
    Self.PropertyChanged;
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', PersonalNr);
  obj.AddPair('ZeitartId', IntToStr(ZeitartId));
  obj.AddPair('Von', FormatDateTime('dd.mm.yyyy', Von));
  obj.AddPair('Bis', FormatDateTime('dd.mm.yyyy', Bis));
  obj.AddPair('DecimalValues', BooleanToStr(DecimalValues));
  helper := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/ValueService/GetZaSumZr', 'application/json',
    obj.ToString);
  client.Free;
  obj.Free;
end;

class function TValueModel.IsZero(Value: string): Boolean;
var
  helper: string;
begin
  if Pos(':', Value) > 0 then
  begin
    Result := true;
    while Value <> '' do
    begin
      helper := Cut(Value, ':');
      Result := Result and (StrToInt(helper) = 0);
    end;
  end
  else
    Result := StrToFloat(Value) = 0;
end;

procedure TValueModel.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TValueModel.SetCol(const Value: Integer);
begin
  FCol := Value;
end;

procedure TValueModel.SetEinheit(const Value: string);
begin
  FEinheit := Value;
end;

procedure TValueModel.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TValueModel.SetRow(const Value: Integer);
begin
  FRow := Value;
end;

procedure TValueModel.SetTage(const Value: string);
begin
  FTage := Value;
end;

procedure TValueModel.SetValue(const Value: string);
begin
  FValue := Value;
end;

end.
